module.exports = __webpack_public_path__ + "img/coming-soon.0ba88e4e.jpg";